import React from "react";
import { Formik, Field, FieldProps, FormikHelpers } from "formik";
import * as S from "./styles";
import {
  getSearchClientFormSchema,
  type SearchClientFormSchema,
} from "./schema";
import { InputWrapper } from "../../components/InputWrapper";
import { DSInput } from "../../components/DSInput";
import DSButton from "../../components/DSButton";
import { TabItem } from "../Tabs";

export type DocType = "cpf" | "client_id";

const docOptions: Record<DocType, { label: string; placeholder: string }> = {
  client_id: {
    label: "ID do cliente",
    placeholder: "Digite o número do ID do cliente",
  },
  cpf: {
    label: "CPF",
    placeholder: "Digite o número do CPF",
  },
};

export interface SearchClientFormProps {
  currentDoc: DocType;
  currentMask: string;
  isSubmitting?: boolean;
  onSubmit: (values: { doc: string }) => Promise<void>;
  onChangeTab: (tab: DocType) => void;
}

export const SearchClientForm: React.FC<SearchClientFormProps> = ({
  currentDoc,
  currentMask,
  isSubmitting = false,
  onSubmit,
  onChangeTab,
}) => {
  const currentDocOption = docOptions[currentDoc];
  const searchClientFormSchema = getSearchClientFormSchema(
    currentDoc,
    currentDocOption
  );

  const tabs: TabItem[] = [
    {
      title: docOptions.cpf.label,
      id: "cpf",
      disabled: isSubmitting,
    },
    {
      id: "client_id",
      title: docOptions.client_id.label,
      disabled: isSubmitting,
    },
  ];

  const handleChangeTab = (
    tabId: string,
    setErrors: FormikHelpers<SearchClientFormSchema>["setErrors"]
  ) => {
    onChangeTab(tabId as DocType);
    setErrors({ doc: undefined });
  };

  return (
    <Formik
      initialValues={{ doc: "" }}
      validationSchema={searchClientFormSchema}
      onSubmit={onSubmit}
    >
      {({ setErrors }) => (
        <S.CustomFormikForm>
          <S.CustomTabs
            tabs={tabs}
            onClick={(tabId) => handleChangeTab(tabId, setErrors)}
          />
          <Field name="doc">
            {({ field, meta }: FieldProps<string>) => (
              <InputWrapper
                error={meta.touched && meta.error ? meta.error : undefined}
                isRequired
                name={field.name}
              >
                <DSInput
                  data-testid="input_documento_portador"
                  disabled={isSubmitting}
                  mask={currentMask}
                  maskChar={null}
                  touched={meta.touched}
                  error={!!meta.error}
                  placeholder={currentDocOption.placeholder}
                  {...field}
                />
              </InputWrapper>
            )}
          </Field>

          <DSButton
            type="submit"
            buttonText="Buscar"
            buttonType="primary"
            height={30}
            style={{
              padding: "0.4rem 1.5rem",
            }}
            isLoading={isSubmitting}
            isDisabled={isSubmitting}
            disabled={isSubmitting}
            data-testid="botao_buscar_portador_ajuste"
          />
        </S.CustomFormikForm>
      )}
    </Formik>
  );
};
